import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { mc } from "../characters/MC";
import { pcLady } from "../characters/PCLady";
import { doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V7PCLadyConvAfter } from "./V7";

export const V7PCLadyConv = async (): Promise<any> => {
    doWaitImageByTime(images.v1.Room1, null, 2);
    if (Question.globalAnswers.v7JoeRivalTextResponse === "cussHim" || Question.globalAnswers.v7JoeRivalTextResponse === "ignored") {
        if (Question.globalAnswers.v7JoeRivalTextResponse === "cussHim") {

            pcLady.talk(`Wow... That wasn't nice at all!`, { method: "Over Chat" });
        } else {
            pcLady.talk(`I can't believe you ignored him like that after he tried making things right.`, { method: "Over Chat" });
        }
        mc.talk(`I wasn't ready to talk to him just yet.`, { method: "On Chat" });
        pcLady.talk(`YET?`, { method: "Over Chat" });
        pcLady.talk(`Does that means both of you made things right in the future?`, { method: "Over Chat" });
        mc.talk(`No spoilers.`, { method: "On Chat" });

        mc.talk(`There is one thing I can share that I only learnt later on...`, { method: "On Chat" });
        pcLady.talk(`SPILL IT!`, { method: "Over Chat" });
        mc.talk(`Joey and Vanessa was really close to a break up.`, { method: "On Chat" });
        pcLady.talk(`Well... I could've guessed that.`, { method: "Over Chat" });
        mc.talk(`Alright, so I'll stop giving future information.`, { method: "On Chat" });
        pcLady.talk(`Don't you dare!`, { method: "Over Chat" });
        pcLady.talk(`Anyway..`, { method: "Over Chat" });
        pcLady.talk(`I'm so glad that he finally got the sense to dump her.`, { method: "Over Chat" });

        mc.talk(`I said close to break up...`, { method: "On Chat" });

    } else {
        pcLady.talk(`Finally!`, { method: "Over Chat" });
        mc.talk(`I actually thought you went to sleep and left me here writing to myself.`, { method: "On Chat" });
        pcLady.talk(`Are you kidding? I'm so invested in the story that I've been holding off on peeing!`, { method: "Over Chat" });
        mc.talk(`And it will only get better...`, { method: "On Chat" });
        mc.talk(`Or worse, depends how you look at it I guess.`, { method: "On Chat" });
        pcLady.talk(`How can there possibly be more?`, { method: "Over Chat" });
        mc.talk(`Wait and see.`, { method: "On Chat" });
        pcLady.talk(`I will, but at least let me comment on some things!\nI've been quiet for soooo long.`, { method: "Over Chat" });
        mc.talk(`Sure.`, { method: "On Chat" });
        pcLady.talk(`I'm so glad that Joe finally got the sense to dump Vanessa.`, { method: "Over Chat" });
        pcLady.talk(`Wait, he will dump her, right?`, { method: "Over Chat" });

    }
    pcLady.talk(`Don't tell me he'll change his mind.`, { method: "Over Chat" });
    if (Question.globalAnswers.v7JoeRivalTextResponse === "cussHim" || Question.globalAnswers.v7JoeRivalTextResponse === "ignored") {
        mc.talk(`As I said. No spoilers...`, { method: "On Chat" });

    } else {
        mc.talk(`No spoilers...`, { method: "On Chat" });

    }
    pcLady.talk(`Fuck!`, { method: "Over Chat" });

    if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
        pcLady.talk(`I also think you made the right call by telling him to break up with her.`, { method: "Over Chat" });
        pcLady.talk(`Wait!`, { method: "Over Chat" });
        await pcLady.setQuestion(new Question({ text: `Don't tell me you convince him to break up because you want her for yourself.`, options: { think: false, method: "Over Chat" }, key: `v7PcLadyToldHerWantVanessa` })
            .option({ title: `Agree`, key: true })
            .option({ title: `Deny`, key: false }));


        if (Question.globalAnswers.v7PcLadyToldHerWantVanessa) {
            await mc.set((properties) => {
                properties.wantVanessaAsGF = true;
            });
            mc.talk(`I won't deny it.`, { method: "On Chat" });
            pcLady.talk(`${mc.name}!`, { method: "Over Chat" });
            pcLady.talk(`That's a nasty move.`, { method: "Over Chat" });
            mc.talk(`I wanted her so bad I couldn't help it...`, { method: "On Chat" });

        } else {
            await mc.set((properties) => {
                properties.wantVanessaAsGF = false;
            });
            mc.talk(`Don't worry. I just want the best for Joe.`, { method: "On Chat" });
            pcLady.talk(`Phew... I'm glad!`, { method: "Over Chat" });
            pcLady.talk(`Got scared there for a second.`, { method: "Over Chat" });
            mc.talk(`Why do you even care so much?`, { method: "On Chat" });
            pcLady.talk(`No reason.`, { method: "Over Chat" });
        }


    } else if (Question.globalAnswers.v7JoeGymToldBreakupVanessa === false) {
        pcLady.talk(`I'm saying this because you told him to stay with her...`, { method: "Over Chat" });
        pcLady.talk(`He really admires you, you might have changed his mind.`, { method: "Over Chat" });
    }

    let name = ``;
    if (mc.properties.emilyRelationship > 0) {
        name += 'Emily';
    }
    if (mc.properties.v7WentWithJennyDate) {
        if (name) {
            name += " and Jenny";
        } else {
            name += `Jenny`;
        }
    }

    if (name) {

        pcLady.talk(`I'll save what I have to say about ${name} for the next time... I wanna see where you are going with that.`, { method: "Over Chat" });
    }

    pcLady.talk(`You can continue now.`, { method: "Over Chat" });
    mc.talk(`Nice, that was short.`, { method: "On Chat" });
    pcLady.talk(`Yes... Because I need to pee.`, { method: "Over Chat" });
    mc.talk(`Should I wait?`, { method: "On Chat" });
    pcLady.talk(`No no! Just start typing and I'll read it in two seconds!`, { method: "Over Chat" });
    if (Question.globalAnswers.v7JoeRivalTextResponse === "cussHim" || Question.globalAnswers.v7JoeRivalTextResponse === "ignored") {
        mc.talk(`So after a while I decided to go for a walk.\nThen I came back home and...`, { method: "On Chat" });


    } else {
        mc.talk(`So I got back home from the gym...`, { method: "On Chat" });

    }

    return jump(V7PCLadyConvAfter, "V7PCLadyConvAfter");
};